import React, { useMemo, useCallback, useState } from "react";

import AppListCalendar from "components/pages/leave-management/app-list-calendar";
import AppGridCalendar from "components/pages/leave-management/app-grid-calendar";
import { usePreselectLeaveRegion } from "hooks/use-leave-region-filter";

const LAYOUT = {
	LIST: "LIST",
	CALENDAR: "CALENDAR",
};

const PageLeaves = (props) => {
	const [layout, setLayout] = useState(LAYOUT.LIST);
	const [currentDate, setCurrentDate] = useState(new Date());

	usePreselectLeaveRegion();

	const isCalendar = useMemo(() => layout === LAYOUT.CALENDAR, [layout]);

	const onLayoutChange = useCallback((type, date) => {
		setCurrentDate(date);

		setLayout(type);
	}, []);

	return (
		<div className="page-leaves">
			<div className="leaves">
				{!isCalendar && <AppListCalendar onLayoutChange={onLayoutChange} currentDate={currentDate} type={LAYOUT.CALENDAR} />}

				{isCalendar && <AppGridCalendar onLayoutChange={onLayoutChange} currentDate={currentDate} type={LAYOUT.LIST} />}
			</div>
		</div>
	);
};

export default PageLeaves;
